import {Utilities} from '@learningblocks/exp-constants';
const {GLOSSARY_API_DETAILS, GlossaryCategoriesList} = Utilities;

export const API_DETAILS = {
  URL: GLOSSARY_API_DETAILS.URL,
  KEY: GLOSSARY_API_DETAILS.KEY,
  ID: 'recctpaSsFTx7NnuX',
};
  
export const CATEGORY_LIST = [
  {
    label: 'All',
    value: GlossaryCategoriesList.all,
    selected: true,
  },
  {
    label: 'Concept',
    value: GlossaryCategoriesList.concepts,
    selected: false,
  },
  {
    label: 'Equipment',
    value: GlossaryCategoriesList.equipment,
    selected: false,
  },
  {
    label: 'Reagent',
    value: GlossaryCategoriesList.reagent,
    selected: false,
  }
];  
  